var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "standard-product-revision-form uk-form-stacked",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submitWithExistingListFieldValues($event)
      }
    }
  }, [_c('h2', {
    staticClass: "uk-margin-medium"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'product',
        params: {
          id: _vm.product.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.product.name))])], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.validity')))]), _vm._v(" "), _c('div', {
    staticClass: "uk-grid-small",
    attrs: {
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-1-4"
  }, [_c('date-time-picker', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.validFrom,
      "label": _vm.$t('fields.validFrom'),
      "max": _vm.fields.values.validUntil,
      "placeholder": "∞"
    },
    model: {
      value: (_vm.fields.values.validFrom),
      callback: function($$v) {
        _vm.fields.values.validFrom = $$v
      },
      expression: "fields.values.validFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-4"
  }, [_c('date-time-picker', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.validUntil,
      "label": _vm.$t('fields.validUntil'),
      "min": _vm.fields.values.validFrom,
      "placeholder": "∞"
    },
    model: {
      value: (_vm.fields.values.validUntil),
      callback: function($$v) {
        _vm.fields.values.validUntil = $$v
      },
      expression: "fields.values.validUntil"
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.details')))]), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.securityInformationUrl,
      "label": _vm.$t('fields.securityInformationUrl'),
      "placeholder": _vm.product.securityInformationUrl,
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.securityInformationUrl),
      callback: function($$v) {
        _vm.fields.values.securityInformationUrl = $$v
      },
      expression: "fields.values.securityInformationUrl"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.altName,
      "label": _vm.$t('fields.altName'),
      "placeholder": _vm.product.altName,
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.altName),
      callback: function($$v) {
        _vm.fields.values.altName = $$v
      },
      expression: "fields.values.altName"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.deliveredItems,
      "label": _vm.$t('fields.deliveredItems'),
      "placeholder": _vm.product.deliveredItems
    },
    model: {
      value: (_vm.fields.values.deliveredItems),
      callback: function($$v) {
        _vm.fields.values.deliveredItems = $$v
      },
      expression: "fields.values.deliveredItems"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.usps,
      "label": _vm.$t('fields.usps'),
      "placeholder": _vm.product.usps
    },
    model: {
      value: (_vm.fields.values.usps),
      callback: function($$v) {
        _vm.fields.values.usps = $$v
      },
      expression: "fields.values.usps"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.summaryTexts,
      "label": _vm.$t('fields.summaryTexts'),
      "placeholder": _vm.product.summaryTexts
    },
    model: {
      value: (_vm.fields.values.summaryTexts),
      callback: function($$v) {
        _vm.fields.values.summaryTexts = $$v
      },
      expression: "fields.values.summaryTexts"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": _vm.$t('fields.alwaysDisplayed')
    },
    model: {
      value: (_vm.fields.values.alwaysDisplayed),
      callback: function($$v) {
        _vm.fields.values.alwaysDisplayed = $$v
      },
      expression: "fields.values.alwaysDisplayed"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": _vm.$t('fields.pxsdbSecureBufferDisabled')
    },
    model: {
      value: (_vm.fields.values.pxsdbSecureBufferDisabled),
      callback: function($$v) {
        _vm.fields.values.pxsdbSecureBufferDisabled = $$v
      },
      expression: "fields.values.pxsdbSecureBufferDisabled"
    }
  }), _vm._v(" "), _c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fields.tags')))]), _vm._v(" "), _c('inheritance-toggle', {
    attrs: {
      "overridden-default": [],
      "toggle-label": "Überschreiben"
    },
    model: {
      value: (_vm.fields.values.tags),
      callback: function($$v) {
        _vm.fields.values.tags = $$v
      },
      expression: "fields.values.tags"
    }
  }, [_c('keyword-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.tags,
      "label": _vm.$t('fields.tags')
    },
    model: {
      value: (_vm.fields.values.tags),
      callback: function($$v) {
        _vm.fields.values.tags = $$v
      },
      expression: "fields.values.tags"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.commonCharger')))]), _vm._v(" "), _c('inheritance-toggle', {
    attrs: {
      "overridden-default": {
        possible: false,
        included: false,
        minWattage: 0,
        maxWattage: 0,
        usbPd: false
      },
      "toggle-label": "Überschreiben"
    },
    model: {
      value: (_vm.fields.values.commonCharger),
      callback: function($$v) {
        _vm.fields.values.commonCharger = $$v
      },
      expression: "fields.values.commonCharger"
    }
  }, [_c('Checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.commonCharger.possible,
      "label": _vm.$t('fields.commonCharger.possible')
    },
    model: {
      value: ((_vm.fields.values.commonCharger || {}).possible),
      callback: function($$v) {
        (_vm.fields.values.commonCharger || {}).possible = $$v
      },
      expression: "(fields.values.commonCharger || {}).possible"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.commonCharger.included,
      "label": _vm.$t('fields.commonCharger.included')
    },
    model: {
      value: ((_vm.fields.values.commonCharger || {}).included),
      callback: function($$v) {
        (_vm.fields.values.commonCharger || {}).included = $$v
      },
      expression: "(fields.values.commonCharger || {}).included"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.commonCharger.minWattage,
      "label": _vm.$t('fields.commonCharger.minWattage'),
      "type": "number"
    },
    model: {
      value: ((_vm.fields.values.commonCharger || {}).minWattage),
      callback: function($$v) {
        (_vm.fields.values.commonCharger || {}).minWattage = _vm._n($$v)
      },
      expression: "(fields.values.commonCharger || {}).minWattage"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.commonCharger.maxWattage,
      "label": _vm.$t('fields.commonCharger.maxWattage'),
      "type": "number"
    },
    model: {
      value: ((_vm.fields.values.commonCharger || {}).maxWattage),
      callback: function($$v) {
        (_vm.fields.values.commonCharger || {}).maxWattage = _vm._n($$v)
      },
      expression: "(fields.values.commonCharger || {}).maxWattage"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.commonCharger.usbPd,
      "label": _vm.$t('fields.commonCharger.usbPd')
    },
    model: {
      value: ((_vm.fields.values.commonCharger || {}).usbPd),
      callback: function($$v) {
        (_vm.fields.values.commonCharger || {}).usbPd = $$v
      },
      expression: "(fields.values.commonCharger || {}).usbPd"
    }
  }), _vm._v(" "), _c('div', {
    slot: "inherited"
  }, [_c('Checkbox', {
    attrs: {
      "disabled": true,
      "has-controls": false,
      "filter": {
        bundle: false
      },
      "label": _vm.$t('fields.commonCharger.possible')
    },
    model: {
      value: (_vm.product.commonCharger.possible),
      callback: function($$v) {
        _vm.product.commonCharger.possible = $$v
      },
      expression: "product.commonCharger.possible"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "disabled": true,
      "has-controls": false,
      "filter": {
        bundle: false
      },
      "label": _vm.$t('fields.commonCharger.included')
    },
    model: {
      value: (_vm.product.commonCharger.included),
      callback: function($$v) {
        _vm.product.commonCharger.included = $$v
      },
      expression: "product.commonCharger.included"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": true,
      "has-controls": false,
      "label": _vm.$t('fields.commonCharger.minWattage'),
      "step": "0.5",
      "min": "0.0",
      "type": "number"
    },
    model: {
      value: (_vm.product.commonCharger.minWattage),
      callback: function($$v) {
        _vm.product.commonCharger.minWattage = _vm._n($$v)
      },
      expression: "product.commonCharger.minWattage"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": true,
      "has-controls": false,
      "label": _vm.$t('fields.commonCharger.maxWattage'),
      "step": "0.5",
      "min": "0.0",
      "type": "number"
    },
    model: {
      value: (_vm.product.commonCharger.maxWattage),
      callback: function($$v) {
        _vm.product.commonCharger.maxWattage = _vm._n($$v)
      },
      expression: "product.commonCharger.maxWattage"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "disabled": true,
      "has-controls": false,
      "filter": {
        bundle: false
      },
      "label": _vm.$t('fields.commonCharger.usbPd')
    },
    model: {
      value: (_vm.product.commonCharger.usbPd),
      callback: function($$v) {
        _vm.product.commonCharger.usbPd = $$v
      },
      expression: "product.commonCharger.usbPd"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.selectors')))]), _vm._v(" "), _c('text-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.size,
      "label": _vm.$t('fields.size'),
      "type": "text"
    },
    model: {
      value: (_vm.fields.values.size),
      callback: function($$v) {
        _vm.fields.values.size = $$v
      },
      expression: "fields.values.size"
    }
  }), _vm._v(" "), _c('memory-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.memory,
      "label": _vm.$t('fields.memory')
    },
    model: {
      value: (_vm.fields.values.memory),
      callback: function($$v) {
        _vm.fields.values.memory = $$v
      },
      expression: "fields.values.memory"
    }
  }), _vm._v(" "), _c('memory-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.storage,
      "label": _vm.$t('fields.storage')
    },
    model: {
      value: (_vm.fields.values.storage),
      callback: function($$v) {
        _vm.fields.values.storage = $$v
      },
      expression: "fields.values.storage"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.features')))]), _vm._v(" "), _c('inheritance-toggle', {
    attrs: {
      "overridden-default": [],
      "toggle-label": "Überschreiben"
    },
    model: {
      value: (_vm.fields.values.features),
      callback: function($$v) {
        _vm.fields.values.features = $$v
      },
      expression: "fields.values.features"
    }
  }, [_c('key-value-table', {
    attrs: {
      "entries": _vm.product.features
    },
    slot: "inherited"
  }), _vm._v(" "), _c('features-manager', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.features
    },
    model: {
      value: (_vm.fields.values.features),
      callback: function($$v) {
        _vm.fields.values.features = $$v
      },
      expression: "fields.values.features"
    }
  })], 1)], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.seo')))]), _vm._v(" "), _c('textarea-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.description,
      "label": _vm.$t('fields.description'),
      "placeholder": _vm.product.description,
      "rows": 5
    },
    model: {
      value: (_vm.fields.values.description),
      callback: function($$v) {
        _vm.fields.values.description = $$v
      },
      expression: "fields.values.description"
    }
  }), _vm._v(" "), _c('input-inheritance-toggle', {
    attrs: {
      "label": _vm.$t('fields.keywords'),
      "overridden-default": [],
      "toggle-label": "Überschreiben"
    },
    model: {
      value: (_vm.fields.values.keywords),
      callback: function($$v) {
        _vm.fields.values.keywords = $$v
      },
      expression: "fields.values.keywords"
    }
  }, [_c('keyword-list-input', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.keywords,
      "label": _vm.$t('fields.keywords')
    },
    model: {
      value: (_vm.fields.values.keywords),
      callback: function($$v) {
        _vm.fields.values.keywords = $$v
      },
      expression: "fields.values.keywords"
    }
  }), _vm._v(" "), _c('div', {
    slot: "inherited"
  }, [_c('separated-list', {
    attrs: {
      "items": _vm.product.keywords
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.legalTexts')))]), _vm._v(" "), _c('inheritance-toggle', {
    attrs: {
      "overridden-default": [],
      "toggle-label": "Überschreiben"
    },
    model: {
      value: (_vm.fields.values.legalTexts),
      callback: function($$v) {
        _vm.fields.values.legalTexts = $$v
      },
      expression: "fields.values.legalTexts"
    }
  }, [_c('legal-text-manager', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.legalTexts
    },
    model: {
      value: (_vm.fields.values.legalTexts),
      callback: function($$v) {
        _vm.fields.values.legalTexts = $$v
      },
      expression: "fields.values.legalTexts"
    }
  }), _vm._v(" "), _c('legal-text-manager', {
    attrs: {
      "has-controls": false,
      "value": _vm.product.legalTexts
    },
    slot: "inherited"
  })], 1)], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.media')))]), _vm._v(" "), _c('inheritance-toggle', {
    attrs: {
      "overridden-default": [],
      "toggle-label": "Überschreiben"
    },
    model: {
      value: (_vm.fields.values.media),
      callback: function($$v) {
        _vm.fields.values.media = $$v
      },
      expression: "fields.values.media"
    }
  }, [_c('attachment-manager', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.media,
      "attachment-type": "MEDIA_OBJECT"
    },
    model: {
      value: (_vm.fields.values.media),
      callback: function($$v) {
        _vm.fields.values.media = $$v
      },
      expression: "fields.values.media"
    }
  }), _vm._v(" "), _c('attachment-manager', {
    attrs: {
      "has-controls": false,
      "value": _vm.product.media
    },
    slot: "inherited"
  })], 1)], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('div', {
    staticClass: "uk-margin-small uk-margin-small-left"
  }, [_c('p', {
    staticClass: "uk-margin-remove"
  }, [_vm._v("Wenn aktiv, wird der Bestand für dieses Produkt, während des PXSDB Imports, im angegebenen Zeitraum nicht importiert/synchronisiert.")]), _vm._v(" "), _c('p', {
    staticClass: "uk-margin-remove"
  }, [_vm._v("Ein manueller Bestand kann hier eingegeben/angepasst werden: "), _c('a', {
    attrs: {
      "href": _vm.productAvailabilityRoute
    }
  }, [_vm._v("Produkt > Verfügbarkeit")])])]), _vm._v(" "), _c('legend', {
    staticClass: "uk-legend uk-margin-top"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.skipStockAvailabilityImport')))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": _vm.$t('fields.stockSkipUpdate')
    },
    model: {
      value: (_vm.fields.values.stockSkipUpdate),
      callback: function($$v) {
        _vm.fields.values.stockSkipUpdate = $$v
      },
      expression: "fields.values.stockSkipUpdate"
    }
  }), _vm._v(" "), (_vm.fields.values.stockSkipUpdate) ? _c('div', {
    staticClass: "uk-grid-small",
    attrs: {
      "div": "",
      "uk-grid": ""
    }
  }, [_c('div', {
    staticClass: "uk-width-1-4"
  }, [_c('date-time-picker', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.stockSkipUpdateFrom,
      "label": _vm.$t('fields.stockSkipUpdateFrom'),
      "max": _vm.fields.values.stockSkipUpdateTo,
      "required": _vm.fields.values.stockSkipUpdate,
      "placeholder": "∞"
    },
    model: {
      value: (_vm.fields.values.stockSkipUpdateFrom),
      callback: function($$v) {
        _vm.fields.values.stockSkipUpdateFrom = $$v
      },
      expression: "fields.values.stockSkipUpdateFrom"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-width-1-4"
  }, [_c('date-time-picker', {
    attrs: {
      "disabled": !_vm.isEditable,
      "errors": _vm.fields.errors.stockSkipUpdateTo,
      "label": _vm.$t('fields.stockSkipUpdateTo'),
      "min": _vm.fields.values.stockSkipUpdateFrom,
      "required": _vm.fields.values.stockSkipUpdate,
      "placeholder": "∞"
    },
    model: {
      value: (_vm.fields.values.stockSkipUpdateTo),
      callback: function($$v) {
        _vm.fields.values.stockSkipUpdateTo = $$v
      },
      expression: "fields.values.stockSkipUpdateTo"
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-medium-top"
  }, [_c('submit-button', {
    attrs: {
      "disabled": !_vm.isSubmittable,
      "type": "primary"
    }
  }), _vm._v(" "), _c('cancel-button')], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-136d57a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/StandardProductRevisionForm.vue
// module id = 1866
// module chunks = 0